export enum ChartType {
    COUNT = 'count',
    VALOR = 'valor',
    VALOR_PAGO = 'valorPago',
    COUNT_PAGO = 'countPago',
}